import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { WifiOff, X } from 'lucide-react';

export default function OfflineIndicator() {
  const { t } = useTranslation();
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showBanner, setShowBanner] = useState(!navigator.onLine);
  const [hasShownOfflineInSession, setHasShownOfflineInSession] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      // Don't show "back online" banner - just hide the offline message
      if (hasShownOfflineInSession) {
        setShowBanner(false);
        setHasShownOfflineInSession(false);
      }
    };

    const handleOffline = () => {
      setIsOnline(false);
      setShowBanner(true);
      setHasShownOfflineInSession(true);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [hasShownOfflineInSession]);

  // Only show banner when offline
  if (!showBanner || isOnline) return null;

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[100] flex items-center justify-center gap-3 px-4 py-3 text-sm font-medium bg-destructive text-destructive-foreground"
    >
      <WifiOff className="h-4 w-4" />
      <span>{t('offline.offlineMessage')}</span>
      <button
        onClick={() => setShowBanner(false)}
        className="ml-2 rounded-full p-1 hover:bg-white/20"
        aria-label={t('common.close')}
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
